import { Tab } from "../../../components/atoms/Tab";
import { useDataProviderContext } from "../DataProvider";
import Activation from "./Activation";
import ExclusiveMembers from "./ExclusiveMembers";
import Overview from "./Overview";
import Release from "./Release";

function MagnetDetailsTabs() {
  const { magnetDetailsState } = useDataProviderContext();
  const { name, image_url: imageURL, type: magnetProgramType } = magnetDetailsState || {};
  return (
    <>
      <div className="mb-2 flex items-center gap-2">
        <img
          src={imageURL}
          className="aspect-1 w-14 rounded-xl border-2 border-white border-opacity-10 object-cover 2xl:w-16"
          alt={name}
        />
        <span
          className="max-w-xl truncate font-sora 
        text-xl font-semibold text-white 2xl:max-w-2xl 2xl:text-2xl 4xl:text-3xl"
        >
          {name}
        </span>
      </div>
      <Tab>
        <Tab.TabPane key="OVERVIEW" tab="OVERVIEW" className="relative pb-1 pt-3 ">
          <Overview />
        </Tab.TabPane>
        <Tab.TabPane key="RELEASES" tab="RELEASES" className="relative pb-1 pt-3">
          <Release />
        </Tab.TabPane>
        <Tab.TabPane key="ACTIVATIONS" tab="ACTIVATIONS" className="relative pb-1 pt-3">
          <Activation />
        </Tab.TabPane>
        {magnetProgramType === 1 && (
          <Tab.TabPane key="EXCLUSIVE MEMBERS" tab="EXCLUSIVE MEMBERS" className="relative pb-1 pt-3">
            <ExclusiveMembers />
          </Tab.TabPane>
        )}
        {/* <Tab.TabPane key="NOTIFICATIONS" tab="NOTIFICATIONS" className="relative pt-3 pb-1">
          <div>Coming Soon</div>
        </Tab.TabPane>
        <Tab.TabPane key="ANALYTICS" tab="ANALYTICS" className="relative pt-3 pb-1">
          <div>Coming Soon</div>
        </Tab.TabPane> */}
      </Tab>
    </>
  );
}

export default MagnetDetailsTabs;
